import { verifyOtp } from "../services/userService";

export const verifyPasswordViaOtp = (data) => (dispatch) => {
    dispatch(request());

    return verifyOtp(data)
        .then((response) => {
            dispatch(success(response));
            return response;
        })
        .catch((error) => {
            dispatch(failure("Please enter a valid email id or mobile no."));
            return {
                status: 400,
                message: "Please enter a valid email id or mobile no.",
            };
        });

    function request() {
        return { type: "VERIFY_PASSWORD_VIA_OTP_REQUEST" };
    }

    function success(data) {
        return { type: "VERIFY_PASSWORD_VIA_OTP_SUCCESS", payload: data };
    }

    function failure(error) {
        return { type: "VERIFY_PASSWORD_VIA_OTP_FAILURE", error };
    }
};
